import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function MapLocation({ fill = 'icon.primary', stroke = 'icon.primary', ...props }) {
  return (
    <IconBase viewBox='0 0 10 14' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 12.3333C5 12.3333 1 8.71296 1 5.40741C1 2.97326 2.79086 1 5 1C7.20914 1 9 2.97326 9
        5.40741C9 8.71296 5 12.3333 5 12.3333Z'
        fill={fill}
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.0026 6.66732C4.08205 6.66732 3.33594 5.92121 3.33594 5.00065C3.33594 4.0801 4.08205
        3.33398 5.0026 3.33398C5.92316 3.33398 6.66927 4.0801 6.66927 5.00065C6.66927 5.92121
        5.92316 6.66732 5.0026 6.66732Z'
        fill='white'
      />
    </IconBase>
  )
}

MapLocation.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
}

export default MapLocation
